<template>
  <Tooltip :content="$t('edit')">
    <BaseButton
      class="edit btn-link"
      type="warning"
      :size="size"
      icon
      @click="click"
    >
      <i class="fas fa-edit"></i>
    </BaseButton>
  </Tooltip>
</template>

<script>
export default {
  name: 'TableEditButton',
  props: {
    size: {
      default: 'sm',
    },
  },
  methods: {
    click(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style scoped></style>
